<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdProjectPlanPrpResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" edit-disable
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"
                                               :disabled="$_notChecked"
                                               custom-label="通知维护KAM"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onNotifyEng"
                                               confirm-text="确认向工程师发送维护KAM通知？"
                                               @click="notifyEngToSelectKam()">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-circle-o-notch"
                                               :disabled="$_notChecked"
                                               custom-label="同步KAM要求时间"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               :busy="onUnpdateKam"
                                               confirm-text="确认用新的OM计划完成时间更新KAM要求时间？"
                                               @click="updateKamRequiredTime()">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-list-alt"
                                               custom-label="KAM行编辑"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="gotoKamSelection()">
                                    </em-button>
                                    <em-button type="edit" custom-icon="fa fa-solid fa-pen-to-square"
                                               :disabled="$_notCheckedOne"
                                               custom-label="KAM Change"
                                               :showName="true"
                                               v-bind:class="'btn btn-outline-primary btn-sm'"
                                               @click="gotoKamSelection(true)">
                                    </em-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

    </div>
</template>
<script>
// Author YuJiaBei
// Date 2021-05-23 09:53:55

import emCommonListMixin from "@/mixin/em/common/list";
import commonViewsUtil from "@/utils/commonViewsUtil";
import emCommonApiMixin from "@/mixin/em/common/api";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "sithMesPrdProjectPlanPrpDmpManageView",
    mixins: [emCommonListMixin, emCommonGotoMixin, emCommonApiMixin, emTableCheckedMixin],
    components: {},
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            onNotifyEng: false,
            onUnpdateKam: false,
        }
    },
    computed: {
        modelName() {
            return 'sithMesPrdProjectPlanPrp'
        },
    },
    mounted() {
        if (this.$route.query.hasOwnProperty('id')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
            this.$refs.emListFilter.doQuery();
        }
    },
    methods: {
        notifyEngToSelectKam() {
            this.onNotifyEng = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/notifyEngToSelectKam?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(() => {
                    commonViewsUtil.showSuccess(this, "通知工程师成功")
                })
                .finally(() => this.onNotifyEng = false)
        },
        updateKamRequiredTime() {
            this.onUnpdateKam = true
            let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateKamRequiredTime?ids=${this.selectIds}`
            this.$_emApiMixin_post(url, {})
                .then(() => {
                    commonViewsUtil.showSuccess(this, "同步KAM要求时间完成")
                })
                .finally(() => this.onUnpdateKam = false)
        },
        gotoKamSelection(isKamChange = false) {
            if (this.$_notCheckedOne) {
                this.$router.push('/sithMes/prd/sithMesPrdProjectKamSelection?currentUserRole=OM');
            } else {
                let projectCode = this.checkedRows[0].projectCode;
                let projectName = this.checkedRows[0].projectName;
                this.$router.push("/sithMes/prd/sithMesPrdProjectKamSelection?projectCode=" + projectCode + "&projectName=" + projectName + '&isKamChange=' + isKamChange);
            }
        }
    }
};
</script>

<style scoped>
</style>